const Intro2 = () => {
  return (
    <div className="intro-content">
      <h1 className="intro-content__title">پایش، تحلیل و غربالگری</h1>

      <p className="u-margin-bottom-small-2">
        در راستای افزایش امنیت اجتماعی شهروندان در دوران بحران های سلامت، وضعیت سلامت تمامی افراد شاغل در حوزه حمل و نقل عمومی به صورت مستمر و بر خط مورد بررسی قرار میگیرد.
      </p>
      <p>
        شهروندان این امکان را خواهند داشت تا در صورت تمایل از طریق وارد نمودن پلاک وسیله نقلیه در بخش حمل و نقل، وضعیت سلامت خدمت دهنده را به صورت لحظه ای و برخط بررسی نمایند.
      </p>
    </div>
  );
}

export default Intro2;